<mvp-layout [thumbnails$]="tagPreviews$"
            [showCaptions]="true"
            (selected)="tagSelected($event)"></mvp-layout>
